<template>
  <div v-loading="loading" class="page-wrap">
    <el-row>
      <el-col :xs="24" :sm="20" :lg="12" :xl="14">
        <el-form label-position="top" size="large" :model="form" :rules="rules" ref="formRef">
          <el-row>
            <el-col :xs="24" :sm="18" :lg="16" :xl="14">
              <el-form-item label="Tashabbuslar doskasi" prop="board">
                <el-select v-model="form.board" style="width: 100%" placeholder="Doskani tanlang">
                  <el-option v-for="board in boards" :key="board.id" :value="board.id" :label="board.title"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="18" :lg="16" :xl="14">
              <el-form-item label="Fayl" prop="file">
                <el-upload
                    ref="uploadRef"
                    class="upload-demo"
                    :auto-upload="false"
                    :multiple="false"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    v-model:file-list="form.file"
                    :limit="1"
                    :on-exceed="onExceed"
                >
                  <template #trigger>
                    <el-button type="primary">Excel faylni tanlang</el-button>
                  </template>

                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="18" :lg="16" :xl="14">
              <el-form-item>
                <el-button class="custom-btn" @click="()=>this.$router.go(-1)">Orqaga</el-button>
                <el-button type="primary" @click="onSubmit">Saqlash</el-button>
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {ElNotification} from "element-plus";

export default {
  name: "ContractorsSync",
  data() {
    return {
      loading: false,
      boards: [],
      form: {
        board: null,
        file: []
      },
      rules:{
        board: [{required: true, message: "Majburiy maydon!", trigger: "change"}],
        file: [{type: 'array', required: true, message: "Majburiy maydon!", trigger: "change"}]
      }
    }
  },
  methods: {
    getBoardList() {
      this.$http.get('api/v1/boards',{params:{status:1}}).then(({data}) => {
        this.boards = data.boards
      }).catch(() => {

      })
    },
    onSubmit() {
      this.$refs.formRef.validate((valid, fields) => {
        if (valid) {
          this.loading = true;
          const formData = new FormData();
          formData.append("board_id", this.form.board)
          formData.append("file", this.form.file[0].raw)
          this.$http.post(`${process.env.VUE_APP_BASE_API_URL}api/v1/chronology/contractors/sync`, formData, {
            headers: {
              // "Authorization": `${store.state.accessToken}`
              "Content-Type": 'multipart/form-data'
            }
          }).then(() => {
            ElNotification.success({
              message: "Amaliyot muvaffaqiyatli bajarildi!"
            });
            this.$router.go(-1)
          }).catch((error) => {
            ElNotification.error({
              message: error.response.data.message || "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!"
            })
          }).finally(() => {
            this.loading = false
          })
        } else {
          console.log('error submit!', fields)
        }
      })
    },
    onExceed(files) {
      this.form.file[0] = files[0]
    }
  },

  mounted() {
    this.getBoardList();
  }
}
</script>

<style scoped>
.page-wrap {
  padding: 20px;
}

.upload-demo {
  width: 100%;
}
</style>